{
  "activity_start_time": "Startzeit der Aktivität",
  "type": {
    "type_of_start_time": "Art der Startzeit",
    "relative": "Relativ zur Sitzung/zum geplanten Element",
    "relative_description": "Beispiel: 2 Minuten nach Sitzungsbeginn oder 5 Minuten nach dem letzten geplanten Termin",
    "fixed": "Behoben",
    "fixed_description": "Beispiel: 09:00",
    "relative_time": "Relative Zeit",
    "fixed_time": "Feste Zeit"
  },
  "start_activity": "Aktivität starten",
  "preposition": {
    "before": "vor",
    "after": "nach"
  },
  "preposition_lables": {
    "before": "vor dem Start von {{ type }}",
    "after": "nach dem Start von {{ type }}"
  },
  "relative_to": {
    "start_time": "Startzeit von",
    "end_time": "Endzeit von",
    "zero_time": "Nullzeit von"
  },
  "relationship": {
    "every": "jeden",
    "specific": "spezifische",
    "first": "erstmalig",
    "last": "zuletzt"
  },
  "related_type": {
    "Session": "Sitzung",
    "Scheduled item": "geplantes Objekt"
  },
  "repeat_activity": {
    "repeat_activity": "Aktivität wiederholen",
    "repeat_on_all": "Wiederhole das an Tagen (alle)",
    "none_selected": "Keine ausgewählt",
    "all_days": "Alle Tage"
  },
  "info": {
    "can_not_delete": "Dieser Zeitplanpunkt kann nicht gelöscht werden, da ein anderer Zeitplanpunkt auf ihn angewiesen ist"
  }
}